import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Heading,
  Text,
  useToast,
  Image,
  Icon,
} from '@chakra-ui/react';
import { AiOutlineCloudUpload } from 'react-icons/ai';

export const UploadPrescription = () => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const toast = useToast();

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!file) {
      toast({
        title: 'Please select a file',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    // Logic to upload file would go here
    toast({
      title: 'Prescription Uploaded!',
      description: 'Our team will review it and contact you soon.',
      status: 'success',
      duration: 5000,
      isClosable: true,
    });
    setFile(null);
    setPreview(null);
  };

  return (
    <Box>
      <VStack spacing={8} py={20} px={5} textAlign="center">
        <VStack spacing={3}>
          <Heading color="teal.600">Upload Prescription</Heading>
          <Text color="gray.600" maxW="600px">
            Don't know which test to book? Just upload your prescription and we'll handle the rest.
          </Text>
        </VStack>

        <Box
          as="form"
          onSubmit={handleSubmit}
          width={['100%', '400px']}
          p={8}
          borderRadius="20px"
          boxShadow="xl"
          bg="white"
          border="2px dashed"
          borderColor="teal.200"
        >
          <VStack spacing={6}>
            <FormControl>
              <FormLabel textAlign="center" cursor="pointer">
                <VStack spacing={4}>
                  {preview ? (
                    <Image src={preview} maxH="200px" borderRadius="md" alt="Preview" />
                  ) : (
                    <Box
                      p={10}
                      borderRadius="full"
                      bg="teal.50"
                      color="teal.500"
                    >
                      <Icon as={AiOutlineCloudUpload} w={12} h={12} />
                    </Box>
                  )}
                  <Text fontWeight="600" color="teal.700">
                    {file ? file.name : 'Click to Select Prescription'}
                  </Text>
                </VStack>
                <Input
                  type="file"
                  accept="image/*,application/pdf"
                  onChange={handleFileChange}
                  display="none"
                />
              </FormLabel>
            </FormControl>

            <Button
              type="submit"
              colorScheme="teal"
              width="100%"
              size="lg"
              boxShadow="lg"
            >
              Submit Prescription
            </Button>
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
};
